import { FC } from "react";
import { FaLightbulb, FaChartLine, FaShieldAlt, FaCogs, FaBalanceScale, FaClipboardCheck } from "react-icons/fa";

interface Feature {
  title: string;
  description: string;
  icon: JSX.Element;
  bgColor: string;
}

const features: Feature[] = [
  {
    title: "Innovación",
    description: "Implementamos tecnología avanzada con GPS e inteligencia artificial para transformar la gestión del transporte y mejorar la eficiencia en la toma de decisiones.",
    icon: <FaLightbulb className="text-blue-500 text-4xl" />,
    bgColor: "bg-gradient-to-tl from-gray-100 to-white shadow-lg",
  },
  {
    title: "Crecimiento",
    description: "Generamos estadísticas semanales y mensuales que te permiten optimizar tus estrategias, aumentar ingresos y mejorar la experiencia de los pasajeros.",
    icon: <FaChartLine className="text-blue-500 text-4xl" />,
    bgColor: "bg-gradient-to-tl from-blue-100 to-white shadow-md",
  },
  {
    title: "Control",
    description: "Brindamos herramientas para monitorear en tiempo real dónde suben y bajan los pasajeros, asegurando mayor transparencia y precisión en la operación.",
    icon: <FaCogs className="text-pink-500 text-4xl" />,
    bgColor: "bg-gradient-to-tl from-pink-100 to-white shadow-md",
  },
  {
    title: "Eficiencia",
    description: "Automatizamos procesos clave para reducir el margen de error, agilizar cobros y garantizar una mejor administración del servicio.",
    icon: <FaClipboardCheck className="text-orange-500 text-4xl" />,
    bgColor: "bg-gradient-to-tl from-orange-100 to-white shadow-md",
  },
  {
    title: "Seguridad",
    description: "Con datos precisos y confiables, minimizamos inconsistencias en los registros, ayudando a prevenir fraudes y mejorar la confianza en la operación.",
    icon: <FaShieldAlt className="text-red-500 text-4xl" />,
    bgColor: "bg-gradient-to-tl from-red-100 to-white shadow-md",
  },
  {
    title: "Flexibilidad",
    description: "Nuestra plataforma es intuitiva y adaptable a las necesidades de cada usuario, permitiendo una gestión personalizada y sin complicaciones.",
    icon: <FaBalanceScale className="text-green-500 text-4xl" />,
    bgColor: "bg-gradient-to-tl from-green-100 to-white shadow-md",
  },
];

const FeaturesSection: FC = () => {
  return (
    <section className="py-16 text-center">
      <h2 className="text-3xl font-bold text-gray-900 mb-10">Que ofrecemos</h2>
      <div className="grid md:grid-cols-3 gap-14 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <div key={index} className={`p-6 rounded-2xl ${feature.bgColor} hover:scale-105 transition-transform`}>
            <div className="flex items-center justify-center mb-4">{feature.icon}</div>
            <h3 className="text-xl font-semibold text-gray-800">{feature.title}</h3>
            <p className="text-gray-600 text-sm mt-2">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
